import { useState } from 'react';

import { Alert, AlertTitle, Button, Typography, InputLabel, MenuItem, Select } from '@mui/material';
import { getBackgroundImage, getLogo, getSlugFromURL } from 'utils/whiteLabel';

import { version } from '../../constants';
import { useAuth } from '../../contexts/auth';
import {
  Container,
  AppHeader,
  AppLogo,
  LoginLogo,
  LoginCardHeader,
  LoginCardFooter,
  NeedsValidation,
  CardLogin,
  LoginCardBody,
} from '../../styles/Styles';

export default function Perfil(props: any) {
  const context = useAuth();
  const PROJECT = getSlugFromURL();
  const [role, setRole] = useState('-1');
  const [show, setShow] = useState(false);

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    if (parseInt(role) > -1) {
      context.selectRole(parseInt(role));
    } else {
      setShow(true);
    }
  };

  const handleChange = (event: any) => {
    setRole(event.target.value as string);
  };

  return (
    <Container
      style={{ backgroundImage: `url(${getBackgroundImage(context.selectedProject ?? PROJECT)})` }}
    >
      <AppHeader>
        <CardLogin>
          <LoginLogo>
            <AppLogo src={getLogo(context.selectedProject ?? PROJECT)} height="135" alt="logo" />
          </LoginLogo>
          <LoginCardHeader
            style={{ backgroundColor: props.headerColor ?? '#000080' }}
          ></LoginCardHeader>
          <LoginCardBody>
            {show ? (
              <Alert className="mb2" variant="filled" severity="error">
                <AlertTitle>Falha ao tentar entrar</AlertTitle>
                Selecione um perfil para entrar.
              </Alert>
            ) : (
              ''
            )}
            <NeedsValidation onSubmit={handleSubmit}>
              <InputLabel id="select-label">Perfil</InputLabel>
              <Select
                labelId="select-label"
                id="select"
                className="mb2"
                fullWidth
                displayEmpty
                value={context.selectedRole >= 0 ? context.selectedRole : role}
                onChange={handleChange}
              >
                <MenuItem value={-1} key="-1">
                  Selecione um perfil
                </MenuItem>
                {context.roles.map((item: any) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>
              <div className="gap-2 d-grid">
                <Button color="primary" type="submit" variant="contained" size="large">
                  <Typography fontSize="16px" fontWeight={600} letterSpacing="0.01em">
                    SELECIONAR
                  </Typography>
                </Button>
              </div>
            </NeedsValidation>
          </LoginCardBody>
          <LoginCardFooter>
            <div className="mt-3 d-flex justify-content-center">
              <Typography variant="caption" color="textSecondary">
                {`versão: ${version}`}
              </Typography>
            </div>
          </LoginCardFooter>
        </CardLogin>
      </AppHeader>
    </Container>
  );
}
